// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","form":"EditBalanceForm_form__1C65M","input":"EditBalanceForm_input__b2eD3"};